import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cf8846e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-flush" }
const _hoisted_2 = { class: "px-7 pt-5 pb-1 d-row border-bottom" }
const _hoisted_3 = { class: "card-title d-flex align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder" }
const _hoisted_5 = {
  key: 0,
  class: "certification-grid"
}
const _hoisted_6 = { class: "certification-mark" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "certification-name" }
const _hoisted_10 = {
  key: 1,
  class: "certification-empty"
}
const _hoisted_11 = { class: "fw-bold fs-6 text-center px-6" }

import { useI18n } from "vue-i18n";
import moment from "moment";
import type { PublicCertification } from "@/modern/types/dashboard";


export default /*#__PURE__*/_defineComponent({
  props: {
    certifications: null,
    title: null,
    emptyLabel: null,
    currentLanguage: null
  },
  setup(__props: any) {

const props = __props as {
  certifications: PublicCertification[];
  title: string;
  emptyLabel: string;
  currentLanguage: string;
}



const { t } = useI18n();

const initials = (name: string) =>
  name
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 4)
    .toUpperCase();

const obtainedLabel = (certification: PublicCertification) => {
  if (!certification.obtained) {
    return t(`${props.currentLanguage}.profile_public.certification_not_obtained`);
  }
  const prefix = t(`${props.currentLanguage}.profile_public.certification_obtained_on`);
  return certification.obtained_at
    ? `${prefix} ${moment(certification.obtained_at).format("DD/MM/YYYY")}`
    : prefix.replace(/\s+(em|on|el)$/i, "");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1)
      ])
    ]),
    (__props.certifications.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.certifications, (certification) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: certification.id,
              to: { name: 'certifications-detail', params: { id: certification.id } },
              class: _normalizeClass(["certification-item", { 'is-locked': !certification.obtained }])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (certification.thumb_url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: certification.thumb_url,
                        alt: certification.name
                      }, null, 8, _hoisted_7))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(initials(certification.name)), 1))
                ]),
                _createElementVNode("span", _hoisted_9, _toDisplayString(certification.name), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["certification-status", certification.obtained ? 'obtained' : 'not-obtained'])
                }, _toDisplayString(obtainedLabel(certification)), 3)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(__props.emptyLabel), 1)
        ]))
  ]))
}
}

})